import { formatISO, parseISO } from 'date-fns';

import type { DateString, DateTimeString } from '../../core/api/schema';
import { apiUrlToId } from './api-url-to-id.util';

// The spec's brands are nominal, so minting one is always an assertion, and the caller is the
// one that names the brand — these are the only places the codebase does either.
/* eslint-disable @typescript-eslint/no-unnecessary-type-parameters, @typescript-eslint/no-unsafe-type-assertion */
export const brandedId = <IdType extends number>(value: number): IdType => value as IdType;

/** A url with no numeric tail yields `NaN`. */
export const idFromApiUrl = <IdType extends number>(url: string): IdType => brandedId<IdType>(parseInt(apiUrlToId(url) ?? ''));

/** `representation: 'date'` is exactly the wire `DateString` (`yyyy-MM-dd`). */
export const toDateString = (value: Date | string): DateString =>
  formatISO(typeof value === 'string' ? parseISO(value) : value, { representation: 'date' }) as DateString;

export const nowAsDateTimeString = (): DateTimeString => new Date().toISOString() as DateTimeString;

/** A wire timestamp that went out through a url and came back as query text. */
export const toDateTimeString = (value: string): DateTimeString => value as DateTimeString;
